import React from 'react'
import styled from 'styled-components'
import {
  Emoji as EmojiData,
  emojiWithName,
  useSendEmoji,
} from 'Event/Dashboard/components/EmojiList/emoji'
import {useTownhallTemplate} from 'Event/template/Townhall'
import {EmojiIcon} from 'Event/template/SimpleBlog/Dashboard/Sidebar/SidebarItem/EmojiList'

export default function Emojis() {
  const template = useTownhallTemplate()
  const {emojiList: list} = template

  return (
    <>
      <Box aria-label="emoji list">
        {list.emojis.map((name, index) => (
          <Container key={index} width={list.emojiWidth}>
            <Emoji emoji={emojiWithName(name)} emojiWidth={list.emojiWidth} />
          </Container>
        ))}
      </Box>
    </>
  )
}

function Emoji(props: {emoji: EmojiData; emojiWidth?: number | null}) {
  const {send, sending} = useSendEmoji()
  const {emoji, emojiWidth} = props

  if (emoji.icon) {
    return (
      <EmojiIcon
        aria-label="event emoji"
        emojiWidth={emojiWidth}
        onClick={send(emoji.name)}
        style={{opacity: sending ? 0.5 : 1}}
      >
        {emoji.icon}
      </EmojiIcon>
    )
  }

  if (emoji.image) {
    return (
      <Image
        aria-label="event emoji"
        src={emoji.image}
        alt={emoji.name}
        onClick={send(emoji.name)}
        style={{opacity: sending ? 0.5 : 1}}
      />
    )
  }

  return null
}

const Box = styled.div`
  height: 100%;
  padding: 0;
  margin-bottom: ${(props) => props.theme.spacing[2]};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 5px;
`

/**
 * Adjust the container according to the following requirements:
 *
 * - If no size is set, the emoji should expand until all available width, shared evenly.
 * - If a size is set, show set size if possible.
 * - If showing set size will stretch container, then render in available width.
 */
const Container = styled((props: any) => {
  const {width: _, ...otherProps} = props
  return <div {...otherProps} />
})`
  display: flex;
  align-items: center;
  margin: 0 ${(props) => props.theme.spacing[3]};
  flex: ${(props) => (props.width ? `0 1 ${props.width}px` : '1')};
  text-align: center;
  justify-content: center;
`

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
`
